import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react'
import {
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Button,
  Input,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSelector } from "react-redux";
// import NaranciaEditor from './NaranciaEditor4'
import NaranciaEditor from './NaranciaEditor8'
import LeftEditorItem from './LeftEditorItem2'
import { _createStartTimes } from '../../../utils/Helper'

// NaranciaEditorBlock
const NaranciaEditorBlock = forwardRef((props, ref) => {

  // forward ref
  useImperativeHandle(ref, () => ({

    getRaw () {

      if (!editorRef.current) {
        console.log("no such editor")
        return
      }
      return editorRef.current.getRaw()

    },

    getStartTimes () {
      return startTimes
    },

  }))

  let editorRef = useRef(null)
  let widthRef = useRef(null)

  let [startTimes, setStartTimes] = useState([])
  let [draftjs, setDraftjs] = useState(null)
  let [startTime, setStartTime] = useState("")
  let [blockIndexes, setBlockIndexes] = useState([])

  // componentDidMount
  useEffect(() => {


    if (props.item && props.item.draftjs) {
      setDraftjs(props.item.draftjs)
    }
    if (props.item && props.item.list1) {

      setStartTimes(props.item.list1)

      console.log("start_index: ", props.item.start_index)

      setStartTime(props.item.list1[0].start)

      let _indexes = []
      for ( let i=0; i<props.item.list1.length; i++ ) {
        _indexes.push(props.item.list1[i].index)
      }
      // console.log("_indexes: ", _indexes)
      setBlockIndexes(_indexes)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.item]);


  // _editorStateUpdated
  let _editorStateUpdated = () => {

    if (!editorRef.current) {
      return
    }

    // re-create start times list
    let blocks =  editorRef.current.getBlocks()

    let editor_width = 730
    if (widthRef.current) {
      editor_width = widthRef.current.offsetWidth
    }

    console.log("editor_width: ", editor_width)

    let _startTimes =  _createStartTimes(blocks, editor_width, props.item.start_index)

    console.log("_startTimes: ", _startTimes)

    setStartTimes(_startTimes)
  }


  return (
    <>

      {/* calculate width */}
      <Row>
        <Col md="2" xs="12" />
        <Col md="8" xs="12">
          <div ref={widthRef} style={{
            width: '100%',
            height: 1,
          }} />
        </Col>
        <Col md="2" xs="12" />
      </Row>

      {/* time and meta */}
      <Row style={{
        // backgroundColor: '#cccccc',
        marginTop: 10,
        marginBottom: 0,
      }}>


        <Col md="2" xs="12" />
        <Col md="8" xs="12">


          {/*<div onClick={_editorStateUpdated} style={{
            cursor: 'pointer',
          }}>
            {startTime}
          </div>*/}


          <FontAwesomeIcon
            onClick={_editorStateUpdated}
            icon="indent"
            style={{
              cursor: 'pointer',
              marginLeft: 10,
              marginRight: 10,
          }}/>

          <FontAwesomeIcon
            onClick={props.saveFix}
            icon="save"
            style={{
              cursor: 'pointer',
              marginLeft: 10,
              marginRight: 10,
              color: '#777777',
          }}/>

        </Col>
        <Col md="2" xs="12" />

      </Row>

      {/* editor */}
      <Row style={{
        marginTop: 0,
        marginBottom: 10,
      }}>

        <Col md="2" xs="12" style={{
          textAlign: 'right',
        }}>

          <div style={{
            // height: 38,
            height: 21,
          }} />

          {startTimes.map((item, idx) => (
            <LeftEditorItem
              togglePlayMedia={props.togglePlayMediaChunk}
              playingBlockIndex={props.playingBlockIndex}
              isPlaying={props.isPlaying}
              key={item.key}
              item={item} />
          ))}

        </Col>

        <Col md="8" xs="12">

          <NaranciaEditor
            ref={editorRef}
            showAlert={props.showAlert}
            key={props.item._id}
            draftjsDefault={draftjs}
            isPlaying={props.isPlaying}
            togglePlayMediaFromWord={props.togglePlayMediaFromWord}
            togglePlayMediaChunk={props.togglePlayMediaChunk}
            stopPlayMediaFromWord={props.stopPlayMediaFromWord}
            playingBlockIndex={props.playingBlockIndex}
            blockIndexes={blockIndexes}
            reCreateChunks={props.reCreateChunks}
            item={props.item} />

        </Col>
        <Col md="2" xs="12" />

      </Row>
    </>
  )
});

export default NaranciaEditorBlock

// playerCurrentTime={props.playerCurrentTime}
